import BaseService from './BaseService'

const ApiService = {
    fetchData(param) {
        return new Promise((resolve, reject) => {
            // Create config object with all parameters
            const config = {
                url: param.url,
                method: param.method,
                data: param.data,
                params: param.params,
                responseType: param.responseType || 'json'
            }
            
            BaseService(config)
                .then((response) => {
                    resolve(response)
                })
                .catch((errors) => {
                    reject(errors)
                })
        })
    },
}

export default ApiService
